type TryFreeButtonProps = {
  loading: boolean
  onTryFree: () => void
}

export function TryFreeButton({ loading, onTryFree }: TryFreeButtonProps) {
  return (
    <button
      type="button"
      onClick={onTryFree}
      disabled={loading}
      className="inline-flex items-center justify-center px-7 py-3.5 bg-gradient-primary text-primary-foreground rounded-md text-base font-semibold shadow-md shadow-primary/25 hover:-translate-y-0.5 hover:shadow-lg transition-all disabled:opacity-50 disabled:hover:translate-y-0 disabled:hover:shadow-md"
    >
      {loading ? '準備しています…' : '無料で試す'}
    </button>
  )
}
